import { AdminValue } from './admin.value';

export class AdminValueDto {
    firstname: string;
    lastname: string;
    email: string;
    password?: string;

    constructor(data: AdminValue) {
        this.firstname = data.firstName;
        this.lastname = data.lastName;
        this.email = data.email;

        if (data.password !== undefined) {
            this.password = data.password;
        }
    }
}
